export default __webpack_public_path__ + "static/media/43687.2d677530.jpg";